/** async load JS
* @param {String} src the src
* @param {Function} callback the callback
* @returns {void} nothing
*/
function loadJS(src, callback) {
	const script = document.createElement('script');
	script.onload = function () {
		callback()
	};
	script.src = src;
	document.head.appendChild(script);
}

loadJS("/js/blazy.js", function() {
	/* globals Blazy */
	new Blazy({
		selector: 'img.lazy',
		successClass: 'loaded'
	});
});

/** runs when the scan has started to enable all the buttons pointing to it
* @returns {void} nothing
*/
function scanStarted() {
	document.querySelector('body').classList.remove('scan-not-started');
	document.querySelector('.timer').innerHTML = '';
}

let lang = document.querySelector('html').getAttribute('lang');
console.log(lang);

loadJS("/js/countdown.js", function() {
	/* globals countdown */
	if (lang === 'nl') {
		countdown.setLabels(
			' milliseconde| seconde| minuut| uur| dag| week| maand',
			' milliseconden| seconden| minuten| uur| dagen| weken| maanden',
			' en ',
			null,
			'even volhouden');
	}

	countdown(
		function(ts) {
			console.log(ts);
			if (ts.value > 0) {
				if (document.querySelector('.timer') !== null) {
					document.querySelector('.timer').innerHTML = '(' + ts.toHTML("strong") + ')';
				}
			}
		},
		new Date(2020, 0, 1),
		countdown.DAYS,
		3
	).toString();

	countdown(
		function(ts) {
			console.log(ts);
			if (ts.value > 0) {
				document.querySelector('.btn-timer').innerHTML = ts.toHTML("strong");
			} else {
				scanStarted();
			}
		},
		new Date(2020, 0, 1),
		countdown.DAYS | countdown.HOURS,
		3
	).toString();
});

/** check scroll position and show the button
		* @returns {void} nothing
		*/
function scrollBtn() {
	var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	if (scrollTop > 200) {
		document.querySelector('body').classList.add('scrolled');
	} else {
		document.querySelector('body').classList.remove('scrolled');
	}
}

window.addEventListener('scroll', scrollBtn, { passive: true });
